export const selectBadge = state => state?.badges;
export const selectBadgeNotification = state =>
  state?.badges?.usersNotifications;
export const selectUpateBadgeNotification = state => state?.badges?.updateBadge;
